import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";

//  HOD Pages
import Dashboard from "./pages/Dashboard";
import Tickets from "./pages/Tickets";
import Workers from "./pages/Workers";
import AddWorker from "./pages/AddWorker";
import Settings from "./pages/Settings";
import Reviews from "./pages/Reviews";
import About from "./pages/About";

//  Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";
import Hods from "./pages/admin/Hods"; 
import Categories from "./pages/admin/Categories"; 
import AdminTickets from "./pages/admin/Tickets"; 
import AdminUsers from "./pages/admin/Users";
import AdminSettings from "./pages/admin/Settings"; 
import AdminLocations from "./pages/admin/Locations";
import TicketSearch from "./pages/admin/TicketSearch"; //  Naya Page Import Kiya

//user pages
import UserDashboard from "./pages/user/UserDashboard";
import UserRaiseIssue from "./pages/user/ManualTerminal";
import UserTickets from "./pages/user/UserTickets";
import UserReviews from "./pages/user/UserReviews";
import UserSettings from "./pages/user/UserSettings";

//  HOD Guard
const HODRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token || role !== "HOD") return <Navigate to="/" replace />;
  return children;
};

//  Admin Guard
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token || role !== "ADMIN") return <Navigate to="/" replace />;
  return children;
};

// User Guard
const UserRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token || role !== "USER") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/*  Public Entry */}
        <Route path="/" element={<Login />} />

        {/*  ADMIN MODULE (Protected) */}
        <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/hods" element={<AdminRoute><Hods /></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin/categories" element={<AdminRoute><Categories /></AdminRoute>} />
        
        {/*  NEW: Ticket Audit Terminal (Search) */}
        <Route path="/admin/ticket-lookup" element={<AdminRoute><TicketSearch /></AdminRoute>} />
        
        <Route path="/admin/tickets" element={<AdminRoute><AdminTickets /></AdminRoute>} />
        <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
        <Route path="/admin/locations" element={<AdminRoute><AdminLocations /></AdminRoute>} />

        {/*  HOD MODULE (Protected) */}
        <Route path="/dashboard" element={<HODRoute><Dashboard /></HODRoute>} />
        <Route path="/tickets" element={<HODRoute><Tickets /></HODRoute>} />
        <Route path="/workers" element={<HODRoute><Workers /></HODRoute>} />
        <Route path="/add-worker" element={<HODRoute><AddWorker /></HODRoute>} />
        <Route path="/reviews" element={<HODRoute><Reviews /></HODRoute>} />
        <Route path="/settings" element={<HODRoute><Settings /></HODRoute>} />
        <Route path="/about" element={<HODRoute><About /></HODRoute>} />

        {/*  USER MODULE (Protected) */}
        <Route path="/user/dashboard" element={<UserRoute><UserDashboard /></UserRoute>} />
        <Route path="/user/raise-issue" element={<UserRoute><UserRaiseIssue /></UserRoute>} />
        <Route path="/user/my-tickets" element={<UserRoute><UserTickets /></UserRoute>} />
        <Route path="/user/reviews" element={<UserRoute><UserReviews /></UserRoute>} />
        <Route path="/user/settings" element={<UserRoute><UserSettings /></UserRoute>} />

        {/*  404 - Unknown route redirect to login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;